import { Link } from 'react-admin';
import { LandingButton } from './LandingButton';

export const ComparePlansButton = () => (
  <LandingButton component={Link} to={'/pricing'}>Compare Plans</LandingButton>
);

